import { render, staticRenderFns } from "./FormattedValue.vue?vue&type=template&id=764df5e7"
import script from "./FormattedValue.vue?vue&type=script&setup=true&lang=js"
export * from "./FormattedValue.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports